"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _mmcDataUtilities = _interopRequireDefault(require("@mmc-tools/mmc-data-utilities"));

var _commonCta = require("@mmc/common-cta");

var _reactLazyLoadImageComponent = require("react-lazy-load-image-component");

var _text = require("@mmc/text");

var _editorialXlCards = _interopRequireDefault(require("../styles/editorial-xl-cards.css"));

var _editorialXlCards2 = _interopRequireDefault(require("./editorial-xl-cards.props/editorial-xl-cards.defaultProps"));

var _editorialXlCards3 = require("./editorial-xl-cards.props/editorial-xl-cards.propTypes");

var _features = _interopRequireDefault(require("./features/features"));

var dataUtils = new _mmcDataUtilities["default"]();
var handleNestedProp = dataUtils.handleNestedProp,
    appendImageTransforms = dataUtils.appendImageTransforms;
var imageWidth = 1080;

var shouldReturnTextAlignment = function shouldReturnTextAlignment(alignment) {
  if (alignment === 'left') {
    return {
      textAlign: 'left'
    };
  }

  if (alignment === 'right') {
    return {
      textAlign: 'right'
    };
  }

  if (alignment === 'center') {
    return {
      textAlign: 'center'
    };
  }

  return {};
};

var getFlexContentAlignment = function getFlexContentAlignment(alignment) {
  if (alignment === 'left') {
    return 'flex-start';
  }

  if (alignment === 'right') {
    return 'flex-end';
  }

  if (alignment === 'center') {
    return 'center';
  }

  return 'left';
};

var Card = function Card(_ref) {
  var theme = _ref.theme,
      data = _ref.data,
      disclaimerData = _ref.disclaimerData;
  return /*#__PURE__*/_react["default"].createElement("div", {
    style: shouldReturnTextAlignment(handleNestedProp(data, 'data.description.textAlignment')),
    className: _editorialXlCards["default"].container + " " + theme['col-xs-12'] + " " + theme['col-sm-5']
  }, /*#__PURE__*/_react["default"].createElement(_reactLazyLoadImageComponent.LazyLoadImage, {
    className: _editorialXlCards["default"].image + " " + theme.marginBottom40,
    src: appendImageTransforms(handleNestedProp(data, 'data.image.image'), imageWidth),
    alt: handleNestedProp(data, 'data.image.altText')
  }), /*#__PURE__*/_react["default"].createElement(_text.Text, {
    text: handleNestedProp(data, 'data.description.sectionHeading'),
    className: theme.marginBottom20 + " " + theme.labelMedium + " " + _editorialXlCards["default"].greyButton,
    disclaimerData: disclaimerData
  }), /*#__PURE__*/_react["default"].createElement(_text.Text, {
    text: handleNestedProp(data, 'data.description.mainHeading'),
    className: theme.marginBottom20 + " " + theme.headingThree,
    tag: "h2",
    disclaimerData: disclaimerData
  }), handleNestedProp(data, 'data.description.legal') ? /*#__PURE__*/_react["default"].createElement(_text.Text, {
    text: handleNestedProp(data, 'data.description.legal'),
    className: theme.marginBottom20 + " " + theme.headingSix,
    disclaimerData: disclaimerData
  }) : '', /*#__PURE__*/_react["default"].createElement(_text.Text, {
    text: handleNestedProp(data, 'data.description.paragraph'),
    className: theme.marginBottom20 + " " + theme.bodyCopy + " " + _editorialXlCards["default"].greyButton,
    disclaimerData: disclaimerData
  }), /*#__PURE__*/_react["default"].createElement(_features["default"], {
    theme: theme,
    features: data.icons,
    disclaimerData: disclaimerData
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: _editorialXlCards["default"].links,
    style: {
      justifyContent: getFlexContentAlignment(handleNestedProp(data, 'data.description.textAlignment'))
    }
  }, /*#__PURE__*/_react["default"].createElement(_commonCta.CommonCta, {
    theme: theme,
    "data-section": handleNestedProp(data, 'data.description.mainHeading'),
    data: {
      label: handleNestedProp(data, 'data.link.label'),
      url: handleNestedProp(data, 'data.link.url'),
      priority: handleNestedProp(data, 'data.link.priority'),
      openNewTab: handleNestedProp(data, 'data.link.openNewTab'),
      icon: handleNestedProp(data, 'data.link.icon'),
      ctaProps: {
        'aria-label': handleNestedProp(data, 'data.description.mainHeading')
      }
    }
  }), data.link2 && /*#__PURE__*/_react["default"].createElement(_commonCta.CommonCta, {
    theme: theme,
    "data-section": handleNestedProp(data, 'data.description.mainHeading'),
    data: {
      label: handleNestedProp(data, 'data.link2.label'),
      url: handleNestedProp(data, 'data.link2.url'),
      priority: handleNestedProp(data, 'data.link2.priority'),
      openNewTab: handleNestedProp(data, 'data.link2.openNewTab'),
      icon: handleNestedProp(data, 'data.link2.icon'),
      ctaProps: {
        'aria-label': handleNestedProp(data, 'data.description.mainHeading')
      }
    }
  }), data.link3 && /*#__PURE__*/_react["default"].createElement(_commonCta.CommonCta, {
    theme: theme,
    "data-section": handleNestedProp(data, 'data.description.mainHeading'),
    data: {
      label: handleNestedProp(data, 'data.link3.label'),
      url: handleNestedProp(data, 'data.link3.url'),
      priority: handleNestedProp(data, 'data.link3.priority'),
      openNewTab: handleNestedProp(data, 'data.link3.openNewTab'),
      icon: handleNestedProp(data, 'data.link3.icon'),
      ctaProps: {
        'aria-label': handleNestedProp(data, 'data.description.mainHeading')
      }
    }
  })));
};

Card.displayName = 'Card';
Card.defaultProps = {
  data: _editorialXlCards2["default"].columns[0]
};
var _default = Card;
exports["default"] = _default;